import http from 'plugins/axios';

export default {
  gethashList(data) {
    return http.get({
      url: '/ta/admin/tenant/workorder/search_deposit',
      data
    });
  },
  getAllCoins() {
    return http.get({
      url: '/ta/admin/tenant/coin/allDisplay'
    });
  },

  getExcelData(data) {
    return http.get({
      url: '/ta/admin/tenant/workorder/getSearchDepositExport',
      data,
      responseType:'blob',
    });
  },
};
